






import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class SubmitButton extends Vue {
  @Prop({ default: "" }) type!: string;

  submit(event: MouseEvent) {
    this.$emit("click", event);
    alert("保存しました");
  }
}
